import { Fragment } from "react";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import CheckoutForm from "../Components/checkoutPageComponent/checkoutForm";
import SDK from "../config";
import { images } from "../Constants/imageslinks.js";
import Header from "../Components/ui/header.jsx";
import MenuComponent from "../Components/reservationPageComponents/menuComponent.jsx";
import Footer from "../Components/ui/footer.jsx";

// const stripePromise = loadStripe(SDK.STRIPE_KEY);
const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_KEY_LIVE);

const cardDetails = [
  {
    icon: images.dollar_icon,
    title: "Lock in a massive lifetime discount",
    description:
      "Today's your lucky day - we charge $49.99 yearly on the app store!",
  },
  {
    icon: images.hands_icon,
    title: "Full refund guarantee",
    description:
      "Not a fan? No problem. Email us for a full refund within 7 days.",
  },
  {
    icon: images.payment_icon,
    title: "Payment secured by Stripe",
    description:
      "The same payment processor Apple, Amazon, Etsy, Walmart & Target use. No credit card details seen or stored by us!",
  },
];

const cards = cardDetails.map((card, index) => (
  <div
    className="bg-primary100 rounded-lg p-6 flex gap-3 items-start"
    key={index}
  >
    <img src={card.icon} alt="refund icon" />
    <div className="flex flex-col gap-3">
      <p className="font-light sm:text-2xl text-lg sm:leading-[100%] leading-[25px] text-secondary100">
        {card.title}
      </p>
      <p className="font-light sm:text-base text-sm sm:leading-[21px] leading-[19px] text-secondary100 max-w-[537px]">
        {card.description}
      </p>
    </div>
  </div>
));

const CheckOutPage = () => {
  return (
    <Elements stripe={stripePromise}>
      <Fragment>
        <div>
          <div className="bg-primary200">
            <div className="lg:hidden">
              <Header />
            </div>
            <div className="block lg:hidden bg-primary100 md:px-8 px-4 pb-4 pt-5 md:pt-0">
              <div className="ml-7 flex items-center justify-start">
                <img src={images.early_access_icon} alt="deposit icon" />

                <div className="sm:w-[122px] w-[110px] h-0.5 bg-secondary100" />

                <img src={images.checkout_icon} alt="payment icon" />

                <div className="sm:w-[122px] w-[110px] h-[1px] bg-primary500/20" />

                <img src={images.confirmation_icon} alt="confirm icon" />
              </div>

              <div className="flex gap-22 relative mt-2 justify-start">
                <p className="font-inter font-light text-sm leading-3.5 whitespace-nowrap	">
                  iOS Access
                </p>
                <p className="font-inter font-medium text-sm leading-3.5 sm:ml-[84px] ml-[71px]">
                  Checkout
                </p>
                <p className="font-inter font-light text-sm leading-3.5 text-dark-100 sm:ml-[74px] ml-[62px]">
                  Confirmation
                </p>
              </div>
            </div>
            <div className="3xl:container 3xl:mx-auto bg-primary300 lg:grid grid-cols-12 flex flex-col-reverse">
              <div className="lg:min-h-screen lg:px-[7vw] md:px-8 px-4 3xl:px-[110px] col-span-7">
                <div className="py-[45px] hidden lg:block">
                  <img src={images.minimis_logo} alt="minimis logo" />
                </div>

                <div className="lg:block hidden">
                  <div className=" ml-7 flex items-center justify-start">
                    <img src={images.early_access_icon} alt="deposit icon" />

                    <div className="lg:w-[122px] md:w-[100px] w-[60px] h-0.5 bg-secondary100" />

                    <img src={images.checkout_icon} alt="payment icon" />

                    <div className="w-[122px] h-[1px] bg-primary500/20" />

                    <img src={images.confirmation_icon} alt="confirm icon" />
                  </div>

                  <div className="flex gap-22 relative mt-2 justify-start">
                    <p className="font-inter font-light text-sm leading-3.5 text-secondary100">
                      iOS Access
                    </p>
                    <p className="font-inter font-medium text-sm leading-3.5 ml-[84px] text-secondary100">
                      Checkout
                    </p>
                    <p className="font-inter font-light text-sm leading-3.5 text-dark-100 ml-[74px] text-secondary100/70">
                      Confirmation
                    </p>
                  </div>
                </div>

                <CheckoutForm />
              </div>

              <MenuComponent />
            </div>

            <div className="px-5 py-5 flex flex-col gap-4 lg:hidden">
              {cards}
            </div>
            <Footer />
          </div>
        </div>
      </Fragment>
    </Elements>
  );
};

export default CheckOutPage;
